export const MEMBERSHIP_DOES_NOT_EXIST_ERROR = 'MEMBERSHIP_DOES_NOT_EXIST_ERROR'

export class MembershipDoesNotExistError extends Error {
  key = MEMBERSHIP_DOES_NOT_EXIST_ERROR

  constructor(public readonly payload?: string) {
    super('Membership does not exist')
  }
}
